import { FC, createContext, Dispatch, ReactNode, SetStateAction, useContext } from "react";
import { BookResponseData, PassengerInputType, ValidityState } from "src/Modules/Flights/constants/JourneyDetails";
import usePayment from "../Steps/Payment/hooks/usePayment";

type JourneyDynamicDetailsContextType = {
  passengersState: [PassengerInputType, Dispatch<SetStateAction<PassengerInputType>>];
  validityState: [ValidityState, Dispatch<SetStateAction<ValidityState>>];
  payment: ReturnType<typeof usePayment>;
};

const JourneyDynamicDetailsContext = createContext<JourneyDynamicDetailsContextType | null>(null);

const JourneyDynamicDetailsProvider: FC<{ children: ReactNode; value: JourneyDynamicDetailsContextType }> = ({ children, value }) => {
  return <JourneyDynamicDetailsContext.Provider value={value}>{children}</JourneyDynamicDetailsContext.Provider>;
};

const useJourneyDynamicDetails = () => {
  const context = useContext(JourneyDynamicDetailsContext);
  if (!context) throw new Error("Illegal Usage of context");
  return context;
};

export { useJourneyDynamicDetails, JourneyDynamicDetailsProvider };
